import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import { ListaCargaValidadorDTO } from "../models/cargaValidacion";
import { format } from "rut.js";


export function useColumns() {

    const COLUMNS: columns<ListaCargaValidadorDTO>[] = [
        {
            name: 'N° operación',
            selector: (row) =>
                row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'Rut cliente',
            selector: (row) => format(row.rut + "-" + row.digitoVerificador),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Beneficio',
            selector: (row) =>
                !row.beneficio ? "" : numericFormatter(row.beneficio?.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": "%" }),
            sortable: true,
            sortField: 'beneficio',
            wrap: true,
            export: true,
        },
        {
            name: 'Motivo rechazo',
            selector: (row) => row.motivoRechazo,
            sortable: true,
            sortField: 'motivoRechazo',
            wrap: true,
            export: true,
        },
    ]


    return { COLUMNS };
}